import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import WrapperComponent from './PrivateRouteWrapper';

export const PrivateRoute = ({ component: Component,...rest }) => {
    return (
        <Route {...rest} render={props => {
            return (
                localStorage.getItem('access_token')
                    ? 
                    <WrapperComponent {...props} >
                        <Component {...props} />
                    </WrapperComponent>
                    : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            )}
        } />
    )
}


// WEBPACK FOOTER //
// ./src/_components/PrivateRoute.jsx